import { supabase } from '../lib/supabase';

/** Total medical_records rows across all pets owned by the user (vault usage). */
export async function countMedicalRecordsForUser(userId: string): Promise<number> {
  const { data: pets, error: petsErr } = await supabase
    .from('pets')
    .select('id')
    .eq('user_id', userId);

  if (petsErr) throw new Error(petsErr.message);

  const ids = pets?.map((r) => r.id) ?? [];
  if (ids.length === 0) return 0;

  const { count, error } = await supabase
    .from('medical_records')
    .select('*', { count: 'exact', head: true })
    .in('pet_id', ids);

  if (error) throw new Error(error.message);
  return count ?? 0;
}
